import apiClient from './index'
import type { LegalEntity, LegalEntityCreate, LegalEntityUpdate } from '@/types'

export const legalEntitiesApi = {
  async getAll(): Promise<LegalEntity[]> {
    const response = await apiClient.get('/ssp/legal-entities', { params: { limit: 100 } })
    return response.data
  },

  async getById(id: number): Promise<LegalEntity> {
    const response = await apiClient.get(`/ssp/legal-entities/${id}`)
    return response.data
  },

  async create(data: LegalEntityCreate): Promise<LegalEntity> {
    const response = await apiClient.post('/ssp/legal-entities', data)
    return response.data
  },

  async update(id: number, data: LegalEntityUpdate): Promise<LegalEntity> {
    const response = await apiClient.put(`/ssp/legal-entities/${id}`, data)
    return response.data
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/ssp/legal-entities/${id}`)
  }
}
